// Constante utilizada para delimitar componentes principalmente en pc manteniendo consistencia en espacios para mejor legibilidad
export const anchoMaximo = '1200px';

// Constante con estilos base para identificar secciones de la pagina
export const estilosSecciones = {
  outline: '1px solid var(--compo-200)',
  shadow: 'md',
  borderRadius: 'sm',
  background: 'layout',
};

// Estilos base para seccion de filtros
export const estilosSeccionFiltros = {
  p: '4',
  w: 'full',
  ...estilosSecciones,
  shadow: 'base',
};
